import { jsx as _jsx } from "react/jsx-runtime";
import { PerspectiveCamera } from "@react-three/drei";
import { useFrame, useThree } from "@react-three/fiber";
import { useRef, useEffect } from "react";
import { Vector3 } from "three";
import { usePreviousValue } from "../../hooks/usePreviousValue";
export default function VTCamera(_a) {
    var _b = _a.makeDefault, makeDefault = _b === void 0 ? true : _b, position = _a.position, _c = _a.fov, fov = _c === void 0 ? 90 : _c, attachToCameraRef = _a.attachToCameraRef, _d = _a.distanceFromCamera, distanceFromCamera = _d === void 0 ? 100 : _d;
    var camRef = useRef();
    var camera = useThree().camera;
    var preAttachToCameraRef = usePreviousValue(attachToCameraRef);
    useFrame(function () {
        if (attachToCameraRef && attachToCameraRef.current && camRef && camRef.current) {
            attachObjectToCamera(attachToCameraRef, camRef);
        }
    });
    function attachObjectToCamera(refToAdd, cameraRef) {
        if (cameraRef && refToAdd) {
            var vector = new Vector3();
            camera.getWorldDirection(vector);
            vector.multiplyScalar(distanceFromCamera);
            vector.add(camera.position);
            refToAdd.current.position.set(vector.x, vector.y, vector.z);
            refToAdd.current.setRotationFromQuaternion(camera.quaternion);
            refToAdd.current.lookAt(0, 0, 0);
        }
    }
    useEffect(function () {
        if (preAttachToCameraRef && preAttachToCameraRef.current) {
            camera.remove(preAttachToCameraRef.current);
        }
    }, [attachToCameraRef]);
    useEffect(function () { }, [preAttachToCameraRef]);
    return (_jsx(PerspectiveCamera, { ref: camRef, makeDefault: makeDefault, position: position ? position : [0, 0, -0.1], fov: fov }));
}
